if (typeof customElements !== 'undefined' && !customElements.get('sf-stepper')) {
  customElements.define('sf-stepper', class extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.index = 0;
      this.interval = Number(this.dataset.interval || 5000);
      this.style.setProperty('--sf-step-duration', `${this.interval}ms`);
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => {
          this.select(i);
          this.stop();
        });
      });
      this.addEventListener('mouseenter', () => this.pause());
      this.addEventListener('mouseleave', () => this.resume());
      this.addEventListener('focusin', () => this.pause());

      this.observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) this.resume();
        else this.pause();
      }, { threshold: 0.35 });
      this.observer.observe(this);
      this.select(0);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      clearTimeout(this.timer);
    }

    select(index) {
      this.index = index;
      this.tabs.forEach((tab, i) => {
        const active = i === index;
        tab.setAttribute('aria-selected', String(active));
        tab.classList.toggle('is-done', i < index);
        const panel = this.querySelector(`#${CSS.escape(tab.getAttribute('aria-controls'))}`);
        if (panel) panel.hidden = !active;
      });
      this.restartLine();
      this.schedule();
    }

    restartLine() {
      const line = this.tabs[this.index]?.querySelector('.sf-stepper__line');
      if (!line) return;
      line.style.animation = 'none';
      void line.offsetWidth;
      line.style.animation = '';
    }

    schedule() {
      clearTimeout(this.timer);
      if (this.reduce || this.stopped || this.paused) return;
      this.timer = setTimeout(() => this.select((this.index + 1) % this.tabs.length), this.interval);
    }

    pause() {
      this.paused = true;
      this.classList.add('is-paused');
      clearTimeout(this.timer);
    }

    resume() {
      if (this.stopped) return;
      this.paused = false;
      this.classList.remove('is-paused');
      this.select(this.index);
    }

    stop() {
      this.stopped = true;
      this.classList.add('is-stopped');
      clearTimeout(this.timer);
    }
  });
}
